// extracted by mini-css-extract-plugin
export default {"label":"Bu0Lib","label--required":"apRJy2","label-text":"ZoaEuH","icon-container":"aEe5mB","information":"WGdSh9","modifier":"zZHthb"};